import {useRef, useState} from "react";
import {Link, useParams} from 'react-router-dom';

import Grid from '@material-ui/core/Grid'
import DialogConfirm from '@base/Dialog/DialogConfirm'
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import CircularProgress from '@material-ui/core/CircularProgress';
import {ObjetoPostalNaoExistenteDialog} from "../Triagem/ObjetoPostalNaoExistenteDialog";
import ButtonPrimary from "@base/Button"
import Title from '@base/Title'
import Subtitle from '@base/Subtitle'
import Toast from '@base/Toast'
import BuscaObjetoPostal from '@base/Inputs/BuscaObjetoPostal'
import ButtonHelp from "@base/Button/ButtonHelp";

import ObjetoPostalService from "@services/ObjetoPostalService"
import {ProcessoResolver} from "@helpers/ProcessoHelper"

import FormularioContagem from '@pages/Contagem/FormularioContagem/FormularioContagem'
import EncaminharObjetoPostalDialog from '@base/Dialog/ObjetoPostal/EncaminharObjetoPostalDialog'
import DetalhamentoObjetosDialog from "@pages/Contagem/DetalhamentoObjetosDialog";

const useStyles = makeStyles(
	(theme) => (
		{
			wrapper: {
				padding: theme.spacing(2)
			},
			title: {
				color : "#333",
				fontSize: 24,
			}
		}
	)
);

export const Contagem = (props) => {
	const [openDialogDetalhamento, setOpenDialogDetalhamento] = useState(false);
	const [openDialogCriarObjetoPostal, setOpenDialogCriarObjetoPostal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [ultimoObjetoPostalSelecionado, setUltimoObjetoPostalSelecionado] = useState({});
	const [objetoPostalSelecionado, setObjetoPostalSelecionado] = useState({});

	const [desContados, setDesContados] = useState();
	const [cartoesN1Contados, setCartoesN1Contados] = useState();
	const [cartoesN2Contados, setCartoesN2Contados] = useState();
	const [cartoesN3Contados, setCartoesN3Contados] = useState();

	const [cartoesN1ContadosInicial, setCartoesN1ContadosInicial] = useState();
	const [cartoesN2ContadosInicial, setCartoesN2ContadosInicial] = useState();
	const [cartoesN3ContadosInicial, setCartoesN3ContadosInicial] = useState();
	const [numeroObjetoPostal, setNumeroObjetoPostal] = useState("");
	const [openModalDiscrepanciaRecontagem,setOpenModalDiscrepanciaRecontagem] = useState();
	const [mensagemDiscrepancia,setMensagemDiscrepancia] = useState();

  const [caixa,setCaixa] = useState();

	const params = useParams();

	const [rec, ] = useState(params.recontagem);

	const processo = ProcessoResolver(params.processo);
	const meuEstilo = useStyles();

	const toastRef = useRef(null);

	const buscaObjetoPostalTextField = useRef(null);

	const [conteudoNaoPrevisto, setConteudoNaoPrevisto] = useState(false);

  const [openEncaminharObjetoPostalDialog, setOpenEncaminharObjetoPostalDialog] = useState(false);
  const [statusMensagem, setStatusMensagem] = useState('');
  const [mensagem, setMensagem] = useState('');
  const fecharDialog = (ObjetoPostal) => {
    if (openDialogCriarObjetoPostal) {
      setOpenDialogCriarObjetoPostal(false);

    }
  }
	const isValido = (obj) => {
		let mensagem = "";

		if(!obj.desContados || obj.desContados < 0) {
			mensagem += `<li>O campo 'DEs' é obrigatório.</li>`;
		}

		if(!obj.cartoesN1Contados || obj.cartoesN1Contados < 0) {
			mensagem += `<li>O campo 'Cartões N1' é obrigatório.</li>`;
		}

		if(!obj.cartoesN2Contados || obj.cartoesN2Contados < 0) {
			mensagem += `<li>O campo 'Cartões N2' é obrigatório.</li>`;
		}

		if(!obj.cartoesN3Contados || obj.cartoesN3Contados < 0) {
			mensagem += `<li>O campo 'Cartões N3' é obrigatório.</li>`;
		}

		return  {
			ok : mensagem === "",
			mensagem : `${mensagem}`
		}

	}

	const calcularDiscrepancia = (valorInicial, valorNovo) => {
		
		valorInicial = valorInicial ?? 0; 
		valorNovo = valorNovo ?? 0;
		
		const diferenca = Math.abs(valorNovo - valorInicial);
		const porcentagem = (diferenca / valorInicial) * 100;
	  
		return porcentagem > 20;
	  }

	const registrarRecontagem = () => {


		const discrepanciaN1 = calcularDiscrepancia(cartoesN1ContadosInicial, cartoesN1Contados);

		const discrepanciaN2 = calcularDiscrepancia(cartoesN2ContadosInicial, cartoesN2Contados);
	
		const discrepanciaN3 = calcularDiscrepancia(cartoesN3ContadosInicial, cartoesN3Contados);

		let texto = "";

		if (discrepanciaN1) {
			texto += '<li><b>Nível 1 </b> - Discrepância superior a 20% em relação a contagem anterior.</li>';
		}

		if (discrepanciaN2) {
			texto += '<li><b>Nível 2 </b> - Discrepância superior a 20% em relação a contagem anterior.</li>';
		}

		if (discrepanciaN3) {
			texto += '<li><b>Nível 3 </b> - Discrepância superior a 20% em relação a contagem anterior.</li>';
		}

		if(texto !== ""){
			setMensagemDiscrepancia(texto);
			setOpenModalDiscrepanciaRecontagem(true);
		}else{
			registrarContagem();
		}

	}

	const registrarContagem = () => {

		setLoading(true);

		let form = {
			"processo" : processo.id,
			"cartoesN1Contados" : cartoesN1Contados,
			"cartoesN2Contados" : cartoesN2Contados,
			"cartoesN3Contados" : cartoesN3Contados,
			"desContados": desContados,
			"conteudoNaoPrevisto" : conteudoNaoPrevisto,
			"numeroObjetoPostal": objetoPostalSelecionado.numeroObjetoPostal,
		}

		let resultadoValidacao = isValido(form);

		if (!resultadoValidacao.ok) {

			toastRef.current.show("error", resultadoValidacao.mensagem);
			setLoading(false);
			

		} else {

			let promises = [];

			if(params.recontagem === "true"){
				promises = [ObjetoPostalService.registrarRecontagem(processo.id, form)]
			}else{
				promises = [ObjetoPostalService.registrarContagem(processo.id, form)];
			}

			Promise.all(promises).then((valores) => {

        if (params.recontagem === "false"
          && cartoesN1Contados === "0"
          && cartoesN2Contados === "0"
          && cartoesN3Contados === "0") {
          toastRef.current.show("warning","O objeto postal foi enviado para recontagem.");

        } else {
          toastRef.current.show("success","Quantitativos salvos com sucesso.");
        }

				limparState();
				finalRedirect();
			}).catch(error => toastRef.current.show("error", "Ocorreu um problema ao salvar o lançamento " + error.response.data.mensagens.map(mensagen => mensagen).join(" ,")))
			.finally ( () => setLoading(false));

		}

		setOpenModalDiscrepanciaRecontagem(false);

	}

	const finalRedirect = () => {
		setLoading(false)
	}

	const limparState = () => {
		setUltimoObjetoPostalSelecionado(objetoPostalSelecionado);
		setObjetoPostalSelecionado({});
		setDesContados("")
		setCartoesN1Contados("");
		setCartoesN2Contados("");
		setCartoesN3Contados("");
		setCartoesN1ContadosInicial("");
		setCartoesN2ContadosInicial("");
		setCartoesN3ContadosInicial("");

		setCaixa("");
		setConteudoNaoPrevisto(false);
		buscaObjetoPostalTextField.current.focus();
    setMensagem("");
    setStatusMensagem("");
	}

	const objetoPostalNaoEncontrado = (objetoPostal) => {
		setOpenDialogCriarObjetoPostal(true)
		setNumeroObjetoPostal(objetoPostal);
	};

	const abrirDialogDetalhamento = (objetoPostal) => {
		console.log("@@@@@@@@@@@@@@@@@@@2");
		setOpenDialogDetalhamento(true);
	}

	const objetoPostalEncontrado = (objetoPostal) => {

    if ((params.recontagem === "false" && objetoPostal.status !== "TRIADO") || (params.recontagem === "true" && objetoPostal.status !== "EM_RECONTAGEM")) {

      if(objetoPostal.status !== "TRIADO" && objetoPostal.status !== "RECEBIDO") setMensagem("Este objeto postal já foi lançado!");

      switch (objetoPostal.status) {
        case "RECEBIDO":
          setMensagem("Este objeto postal precisa estar triado para ser contado!");
          setStatusMensagem('Triagem');
          break;
        case "TRIADO":
          setMensagem("Este objeto postal precisa ser lançado!");
          setStatusMensagem('Lançamento');
          break;
        case "LANCADO":
          setStatusMensagem('Digitalização');
          break;
        case "EM_RECONTAGEM":
          setStatusMensagem('Recontagem');
          break;
        case "FINALIZADO":
          setStatusMensagem('Armazenamento');
		  break
		default: 
			break;
      }

      setOpenEncaminharObjetoPostalDialog(true);

   	} else {

			setObjetoPostalSelecionado(objetoPostal);

			if(params.recontagem === "true"){

				//let des = objetoPostal.desContados;
				let n1Contados = objetoPostal.cartoesN1Contados;
				let n2Contados = objetoPostal.cartoesN2Contados;
				let n3Contados = objetoPostal.cartoesN3Contados;
				setCartoesN1ContadosInicial(n1Contados + "");
				setCartoesN2ContadosInicial(n2Contados+ "");
				setCartoesN3ContadosInicial(n3Contados+ "");
				if(objetoPostal.motivoRecontagem){
					if(objetoPostal.motivoRecontagem.includes("Documento de Envio")){
						//des = "";
					}
					if(objetoPostal.motivoRecontagem.includes("Nível 1")){
						n1Contados = "";
					}
					if(objetoPostal.motivoRecontagem.includes("Nível 2")){
						n2Contados = "";
					}
					if(objetoPostal.motivoRecontagem.includes("Nível 3")){
						n3Contados = "";
					}
				}

				//setDesContados(des + "");
				//setCartoesN1Contados(n1Contados + "");
				//setCartoesN2Contados(n2Contados+ "");
				//setCartoesN3Contados(n3Contados+ "");
				

				setConteudoNaoPrevisto(objetoPostal.conteudoNaoPrevisto);

			}else{
				setCaixa(objetoPostal.caixaCodigo);
			}
		}

	}

	return (
		<>
			<Toast ref={toastRef} />

			<Title>{params.recontagem === "true" ? "Recontagem" : <>Lançamento <ButtonHelp tipo="LANCAMENTO" /></>}</Title>
			{(params.recontagem === "true" || rec ==="true") && objetoPostalSelecionado.numeroObjetoPostal !== undefined ?
					<div style={{float:'right',display:'block'}}>
					<ButtonPrimary onClick={abrirDialogDetalhamento}
						name="Consultar Objetos por Cartão"
						disabled={loading} /></div>
				: <></>}	
			<br/>
			<Grid item container spacing={3}>
				<Grid item sm={8} lg={8}>
				{(objetoPostalSelecionado === undefined || objetoPostalSelecionado.numeroObjetoPostal === undefined) &&
					<BuscaObjetoPostal
						inputRef={buscaObjetoPostalTextField}
						size={4}
						autoFocus
						processo={processo}
						aoencontrar={objetoPostalEncontrado}
						aonaoencontrar={objetoPostalNaoEncontrado}
					/> }

				</Grid>
				{ultimoObjetoPostalSelecionado.id ?
				<Grid item sm={4} lg={4}>
					<div style={{backgroundColor:"#fff",padding:20}}>
					<Subtitle style={{margin:0,fontSize:15}}>Último Objeto Postal Contado:</Subtitle>
					{ultimoObjetoPostalSelecionado.numeroObjetoPostal}<br/>
					<Link style={{cursor:"pointer", fontWeight: "bold"}} to={`/${processo.id}/objetosPostais/${ultimoObjetoPostalSelecionado.numeroObjetoPostal}`}>Consultar</Link>
					</div>

				</Grid> : <></> }
			</Grid>

			

			{objetoPostalSelecionado.numeroObjetoPostal !== undefined &&
				<>
					<FormularioContagem
						numeroObjetoPostal={objetoPostalSelecionado.numeroObjetoPostal}
						caixa={caixa}

						recontagem={params.recontagem === "true"}

						motivoRecontagem={objetoPostalSelecionado.motivoRecontagem}
						numeroRecontagens={objetoPostalSelecionado.numeroRecontagens}

						conteudoNaoPrevisto={conteudoNaoPrevisto}
						handleConteudoNaoPrevisto={setConteudoNaoPrevisto}

						desContados={desContados}
						handleDesContados={setDesContados}

						cartoesN1Contados={cartoesN1Contados}
						handleCartoesN1Contados={setCartoesN1Contados}

						cartoesN2Contados={cartoesN2Contados}
						handleCartoesN2Contados={setCartoesN2Contados}

						cartoesN3Contados={cartoesN3Contados}
						handleCartoesN3Contados={setCartoesN3Contados}

					/>

					<br />
					<Paper className={meuEstilo.wrapper}>
						<ButtonPrimary
							onClick={params.recontagem === "true" ? registrarRecontagem : registrarContagem}
							name="Salvar"
							startIcon={loading ? <CircularProgress size={16} /> : <AddIcon />}
							disabled={loading}
						/>
					</Paper>

				</>
			}

{openModalDiscrepanciaRecontagem &&
			<DialogConfirm
					maxWidth={"sm"}
					text={mensagemDiscrepancia}
					close={() => setOpenModalDiscrepanciaRecontagem(false)}
					open={openModalDiscrepanciaRecontagem}
					title={"ATENÇÃO!!!"}
					handleConfirm={registrarContagem}
				  />
}

{openDialogDetalhamento &&
			<DetalhamentoObjetosDialog
				
					text={mensagemDiscrepancia}
					close={() => setOpenDialogDetalhamento(false)}
					open={openDialogDetalhamento}
					title={"Consultar objetos por cartão"}
					objetoPostal={objetoPostalSelecionado.numeroObjetoPostal}
					//handleConfirm={registrarContagem}
				  />
}


 {openDialogCriarObjetoPostal &&
		<ObjetoPostalNaoExistenteDialog
		  aoFechar={fecharDialog}
		  aberto={openDialogCriarObjetoPostal}
		  objetoPostal={numeroObjetoPostal}
		  processo={processo}

		/>
	  }

      {openEncaminharObjetoPostalDialog &&
        <>
          <EncaminharObjetoPostalDialog
            mensagem ={mensagem}
            statusMensagem={statusMensagem}
            close={() => {
              limparState();
              setOpenEncaminharObjetoPostalDialog(false);
            }}
            open={openEncaminharObjetoPostalDialog}
          />
        </>
      }
		</>
	);
}

export default Contagem;
